module.exports = __webpack_public_path__ + "img/logo-sem-fundo.0f46fc42.png";